// extracted by mini-css-extract-plugin
var _1 = "PhoneSelect-modulebutton__rVX0Y";
var _2 = "PhoneSelect-moduleflagIcon__gVL6y SelectEntityItemAvatar-moduleavatar__zeGPU";
var _3 = "PhoneSelect-moduleicon__eq9cf";
var _4 = "PhoneSelect-moduleiconContainer__Vy_Pv IconNG-moduleiconContainer__SxWZ0";
var _5 = "PhoneSelect-moduleselect__l6AC6";
var _6 = "PhoneSelect-moduletext__ShVa4";
export { _1 as "button", _2 as "flagIcon", _3 as "icon", _4 as "iconContainer", _5 as "select", _6 as "text" }
